<style lang="scss">
    .share-cart-modal{
        .md-check > i:before{
            width: 16px !important;
            height: 16px !important;
            border-radius: 3px !important;
            border: 1px solid #a7a7a7 !important;
        }

        .md-check > i:after{
            left: 6px !important;
            top: 1px !important;
            width: 5px !important;
            height: 12px !important;
        }

        .copyButton{
            padding: 10px 50px !important;
            margin-right: -1px;
        }

        .copyInput{
            min-height: 37px !important;
            border-radius: 5px 0px 0px 5px !important;
        }

        .help-block{
            font-size : 11px !important;
        }

        .modal-footer {
            border: none;
        }

        @media (max-width: 767px) {
            .input-group {
                .copyButton{
                    padding: 10px 20px !important;
                }
            }
        }
    }
</style>>

<template>
    <div class="share-cart-modal modal fade" id="shareCartModal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12">
                                    <h4 class="modal-title" :style="$highlightColor">Share Cart</h4>
									<div style="overflow: auto">
                                        <div class="col-xs-12" style="">
                                            <p>Want to share your cart with someone else? You can do this by copying the URL generated below and anyone else who visits the link will see the same cart and be able to checkout.</p>
                                            <div class="form-group">
                                                <label for="" class="control-label">Share Cart URL</label>

                                                <div class="input-group">
                                                    <input type="text" class="form-control copyInput" id="shareUrl" v-model="shareUrl" >
                                                    <span class="input-group-btn">
                                                        <button class="btn btn-default copyButton copyToClipboard btn-success" type="button" data-clipboard-target="#shareUrl">
                                                            Copy
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="" class="control-label">Short Url</label>
                                                <template v-if="shortUrlLoading || !shortUrl">
													<p class="text-center"><font-awesome-icon icon="spinner-third" spin></font-awesome-icon></p>
												</template>
                                                <div class="input-group" v-if="!shortUrlLoading || shortUrl">
                                                    <input type="text" class="form-control copyInput" id="shareShortUrl" v-model="shortUrl">
                                                    <span class="input-group-btn">
                                                        <button class="btn btn-default copyButton copyToClipboard btn-success" type="button" data-clipboard-target="#shareShortUrl">
                                                            Copy
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>

                                            

                                            <div class="clearfix">
                                                <div class="checkbox needsclick text-left">
                                                    <label>
                                                        <input type="checkbox" v-model="checkout" class="has-value needsclick">
                                                        <i class="green"></i>
                                                        <span>Direct To Checkout</span>
                                                    </label>
                                                </div>
                                                <span class="help-block">Bypass the store altogether and direct the share link straight to the checkout with the selected items in cart ready for payment.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
								
								<div class="modal-footer">
									<button type="button" class="btn btn-close" data-dismiss="modal" :style="$mainButtonStyle">Close</button>
								</div>
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	import Clipboard from 'clipboard'
    import Configure from "../../mixins/configure";
	import SecondaryModal from '../../mixins/secondary-modal'

    export default {
        mixins:[Configure, SecondaryModal],
        mounted() {
            new Clipboard('.copyToClipboard');
            this.shortUrl = this.shorten();
        },
        data() {
            return {
                shortUrlLoading: false,
                shortUrl: null,
                baseUrl: ab.baseUrl,
                checkout: false,
            }
        },
        computed: {
            cart() {
				return this.$store.state.cart
			},
            coupon() {
                return this.$store.state.coupon;
            },
            configuration() {
                return this.$store.state.currentConfig;
            },
            cartEmpty() {
                return this.cart.getCart().length == 0
            },
            shareUrl() {
                let url = this.baseUrl;

                if (this.checkout) {
                    url += '/checkout';
                }

                let path = ""

                if (this.configuration && this.configuration.id && !this.configuration.default) {
                    path += `?config_id=${this.configuration.id}`;
                }

                if (this.coupon && this.coupon.code) {
                    let couponPath = (path == "") ? '?' : '&'
					couponPath += `coupon=${this.coupon.code}`

                    path += couponPath;
                }

                let cartString = this.cart.base64EncodedCart();
                if (cartString) {
                    let cartPath = (path == "") ? '?' : '&'
					cartPath += `cart=${cartString}`
                    path += cartPath;
                }    

                return url + path;
            },
        },
        methods: {
            shorten() {
                this.shortUrlLoading = true;

                this.$http.get(`${ab.apiUrl}/url/short`, {
                    params: {
                        url: this.shareUrl
                    }
                }).then((response) => {
                    this.shortUrl = response.data.short;
                    this.shortUrlLoading = false;
                }).catch((error) => {
                    this.shortUrlLoading = false;
                });
            }
        },
        watch: {
            shareUrl() {
                this.shortUrl = this.shorten();
            }
        }
    }
</script>
